/**
 * @param {Record<string, unknown>|null|undefined} vm
 * @returns {{ key: string, label: string } | null}
 */
export function extractOrgTourDestinationChip(vm) {
  if (!vm || typeof vm !== "object") return null;
  const tour = String(vm.tourName ?? "").trim() || "טיול מאורגן";
  const route = String(vm.routeLabel ?? "").trim();
  const label = route ? `${tour} — ${route}` : tour;
  const key = label.toLowerCase();
  if (!key) return null;
  return { key, label };
}

/**
 * צ׳יפי יעד / שם טיול מתוך רשימת VMs (תוצאות הטעינה).
 * @param {Array<Record<string, unknown>>} vms
 * @returns {{ chips: Array<{ key: string, label: string, count: number }>, detectedKeys: string[] }}
 */
export function buildOrgTourDestinationChips(vms) {
  const rows = Array.isArray(vms) ? vms : [];
  const counts = new Map();
  const labels = new Map();
  for (const vm of rows) {
    const ex = extractOrgTourDestinationChip(vm);
    if (!ex?.key) continue;
    counts.set(ex.key, (counts.get(ex.key) || 0) + 1);
    if (!labels.has(ex.key)) labels.set(ex.key, ex.label);
  }
  const detectedKeys = [...counts.keys()].sort((a, b) =>
    (labels.get(a) || "").localeCompare(labels.get(b) || "", "he")
  );
  const chips = detectedKeys.map((key) => ({
    key,
    label: labels.get(key) || key,
    count: counts.get(key) || 0,
  }));

  if (import.meta.env?.DEV) {
    console.log("[ORG_TOUR_DESTINATION_CHIPS_BUILD]", {
      totalResults: rows.length,
      detectedKeys,
      chips: chips.map((c) => `${c.label} (${c.count})`),
    });
  }

  return { chips, detectedKeys };
}
